import { inject } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalDataService } from './global.data.service';

export const responseInterceptor = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
	const router = inject(Router);

	return next(request).pipe(
		catchError((error: any) => {
			if (error instanceof HttpErrorResponse) {
				if (error.status >= 400) {
					console.error('Erro HTTP:', error.message || error.statusText);
				}
				if (error.status === 403) {
					return EMPTY;
				}
				if (error.status === 201) {
					return throwError(() => true);
				}
			}
			return throwError(() => error);
		})
	);
};
